(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-cc-catalog]').forEach((root) => {
      if (root.dataset.ccReady) return;
      root.dataset.ccReady = 'true';
      const panel = root.querySelector('[data-cc-filters]');
      const toggle = root.querySelector('[data-cc-filter-toggle]');
      if (toggle && panel) {
        toggle.hidden = false;
        panel.hidden = Number(panel.dataset.active) === 0;
        toggle.setAttribute('aria-expanded', String(!panel.hidden));
        toggle.addEventListener('click', () => {
          panel.hidden = !panel.hidden;
          toggle.setAttribute('aria-expanded', String(!panel.hidden));
        });
      }
      root.querySelectorAll('[data-cc-sort]').forEach((form) => {
        const select = form.querySelector('select');
        select.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', select.value);
          url.searchParams.delete('page');
          window.location.assign(url.toString());
        });
      });
      if (panel) {
        const minimum = panel.querySelector('input[name$=".gte"]');
        const maximum = panel.querySelector('input[name$=".lte"]');
        panel.addEventListener('input', () => { if (minimum) minimum.setCustomValidity(''); });
        panel.addEventListener('submit', (event) => {
          if (minimum && maximum && minimum.value !== '' && maximum.value !== '' && Number(minimum.value) > Number(maximum.value)) {
            event.preventDefault();
            minimum.setCustomValidity(minimum.validationMessage || panel.dataset.rangeError || 'Minimum > maximum');
            minimum.reportValidity();
            return;
          }
          event.preventDefault();
          const url = new URL(panel.action);
          const data = new FormData(panel);
          data.forEach((value, key) => { if (String(value).trim() !== '') url.searchParams.append(key, value); });
          window.location.assign(url.toString());
        });
      }
      root.addEventListener('click', (event) => {
        const link = event.target.closest('[data-cc-action]');
        if (!link) return;
        document.dispatchEvent(new CustomEvent('canalla:collection-action', { detail: { action: link.dataset.ccAction, productId: link.dataset.productId, sectionId: root.dataset.sectionId } }));
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#CollectionGuide"]');
    if (!link) return;
    const guide = document.getElementById('CollectionGuide');
    if (guide) guide.open = true;
  });
})();
